/**
 * Utility for webview
 */

export const isInWebView = () => {
  return window && window.venice
}

export const callReAuth = () => {
  if (isInWebView() && typeof window.venice.reAuth === 'function') {
    window.venice.reAuth()
  }
}
